import styles from "./AnalyticsBarList.module.scss";
import { AnalyticsCardType } from "../card/AnalyticsCard";

// Below this the bar is too short to hold a label, so it moves out beside the bar
// rather than being clipped.
const INSIDE_LABEL_MIN_PERCENT = 12;

export interface AnalyticsBarRow {
	label: string;
	/** 0–100 — the width of the bar. */
	percent: number;
	/** Text drawn inside the bar. Left out leaves the bar plain, and thinner. */
	insideLabel?: string;
	/** Text after the track — a count, a share, a note. */
	trailing?: string;
	/**
	 * Colours the bar, and the trailing text with it. A tone always arrives with
	 * `trailing`, so what the colour means is spelled out and never left to colour.
	 */
	tone?: AnalyticsCardType;
}

type Props = {
	/** Drawn in the order given — the component does not sort. */
	rows: AnalyticsBarRow[];
};

/**
 * The bars on their own, with no card or heading around them — for a card that holds
 * more than this. AnalyticsBarList is the same thing in a card of its own.
 */
const AnalyticsBars = ({ rows }: Readonly<Props>) => (
	<ol className={styles.rows}>
		{rows.map(row => {
			const fits = row.percent >= INSIDE_LABEL_MIN_PERCENT;

			return (
				<li key={row.label} className={`${styles.row} ${styles[row.tone ?? "neutral"]}`}>
					<span className={styles.label}>{row.label}</span>
					<div className={`${styles.track} ${row.insideLabel ? "" : styles.thin}`}>
						<div className={styles.bar} style={{ width: `${row.percent}%` }}>
							{row.insideLabel && fits && <span className={styles.insideLabel}>{row.insideLabel}</span>}
						</div>
						{row.insideLabel && !fits && <span className={styles.outsideLabel}>{row.insideLabel}</span>}
					</div>
					{row.trailing && <span className={styles.trailing}>{row.trailing}</span>}
				</li>
			);
		})}
	</ol>
);

export default AnalyticsBars;
